import axios from '../../core/services/axios';
// eslint-disable-next-line import/prefer-default-export
export const getOrganizations = () => axios.get('/api/organizations', {
  params: {
    page: 1,
    perPage: 999,
  },
});

/** With initiative_id & organization_id */
export const getRegistrationForms = (params) => axios.get('/api/registration-forms/', {
  params: {
    page: 1,
    perPage: 999,
    ...params,
  },
});
